import { ThreeSixtyQARow } from "../api/ThreeSixty";
import { GenericObject } from "./FilterSortHeader";
import { usePermissionValidator } from "../api/UserPermissionValidators";
import { ThreeSixtyRowRendererBase } from "./ThreeSixtyRowRendererBase";
import { ThreeSixtyAssignedToCell } from "./ThreeSixtyAssignedToCell";

type ThreeSixtyQARowProps = {
  row: ThreeSixtyQARow | GenericObject;
  cancel: string[];
  toggleCancel: (value: string) => number;
  forceReload: () => void;
};

export const ThreeSixtyQARowRenderer = (props: ThreeSixtyQARowProps) => {
  const { row, cancel, toggleCancel, forceReload } = props;
  const perms = usePermissionValidator();

  return (
    <ThreeSixtyRowRendererBase
      row={row}
      cancel={cancel}
      toggleCancel={toggleCancel}
      linkPath="/qa-workbench"
      canShowLink={perms.canEdit360Qa}
      afterDueDateColumns={
        <ThreeSixtyAssignedToCell
          workflowRunUuid={row.workflow_run_uuid}
          lockedBy={row.locked_by}
          onRefresh={forceReload}
        />
      }
    />
  );
};
